'use client';

import { useEffect } from 'react';
import { useUser } from '@clerk/nextjs';
import { identifyUser, resetUser } from '@/lib/analytics/posthog';

/**
 * Component that identifies the current user in PostHog when they sign in
 * and resets the user when they sign out
 */
export default function PostHogUserIdentifier() {
  const { isSignedIn, user } = useUser();

  useEffect(() => {
    if (isSignedIn && user) {
      // Identify the user in PostHog with their Clerk ID and email
      identifyUser(user.id, {
        email: user.primaryEmailAddress?.emailAddress,
        name: user.fullName,
        clerk_id: user.id,
      });
    } else {
      // Reset the user when they sign out
      resetUser();
    }
  }, [isSignedIn, user]);

  // This component doesn't render anything
  return null;
}
